var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconRocket = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M25.5,5c-0.1-0.3-0.3-0.5-0.5-0.5c-1.1-0.2-2.3-0.3-3.5-0.3c-4.4,0-7,2.3-8.9,5.4H8.2\n\tc-0.8,0-1.5,0.4-1.8,1.1l-2.1,4.2c-0.3,0.5,0,1.1,0.5,1.4c0.1,0.1,0.3,0.1,0.5,0.1h4.4l-1,1c-0.5,0.5-0.5,1.4,0,1.9l2.2,2.2\n\tc0.5,0.5,1.4,0.5,1.9,0l1-1v4.4c0,0.6,0.5,1,1,1c0.2,0,0.3,0,0.5-0.1l4.2-2.1c0.7-0.3,1.1-1,1.1-1.8v-4.4c3.1-2,5.4-4.6,5.4-8.9\n\tC25.9,7.3,25.8,6.1,25.5,5L25.5,5z M20.4,11.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7\n\tC22.1,10.5,21.4,11.3,20.4,11.3C20.4,11.3,20.4,11.3,20.4,11.3L20.4,11.3z" }))));
});
export default IconRocket;
//# sourceMappingURL=IconRocket.js.map